
import React, { useState, useEffect } from 'react';
import { fetchAllExamResults } from '../../../../api/quizResultApi';
import CustomTable from '../../../../components/CustomTable/CustomTable';
import './Reports.css';

export default function Reports() {
  const [results, setResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [userName, setUserName] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
    document.title = 'Reports - Finhaat Gurukul';
    fetchResults();
  }, []);

  const fetchResults = async () => {
    try {
      setIsLoading(true);
      const data = await fetchAllExamResults();
      
      const sortedData = data.sort((a, b) => b.userExamId - a.userExamId);
      setResults(sortedData);
      setFilteredResults(sortedData);
      setTotalRows(sortedData.length);
    } catch (error) {
      console.error('Error fetching results:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userName) {
      const filtered = results.filter(result =>
        result.userName.toLowerCase().includes(userName.toLowerCase())
      );
      setFilteredResults(filtered);
      setTotalRows(filtered.length);
      setCurrentPage(1);
    } else {
      setFilteredResults(results);
      setTotalRows(results.length);
    }
  }, [userName, results]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const columns = [
    {
      name: 'User Name',
      selector: row => row.userName,
      sortable: true,
    },
    {
      name: 'Exam Name',
      selector: row => row.examName,
      sortable: true,
    },
    {
      name: 'Exam Type',
      selector: row => row.examTypeDesc,
      sortable: true,
    },
    {
      name: 'Total Questions',
      selector: row => row.totalQuestions,
      sortable: true,
    },
    {
      name: 'Attempted Questions',
      selector: row => row.attemptedQuestions,
      sortable: true,
    },
    {
      name: 'Correct Answers',
      selector: row => row.correctAnswers,
      sortable: true,
    },
    {
      name: 'Score',
      selector: row => row.score,
      sortable: true,
      cell: row => (
        <span className={`px-2 py-1 rounded ${row.score > 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {row.score > 0 ? 'Passed' : 'Failed'}
        </span>
      ),
    },
  ];

  return (
    <div className="p-6 container mx-auto">
      <h1 className="text-md font-[550] mb-6 text-gray-800">Exam Reports</h1>
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search by User Name"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          className="p-2 border border-gray-300 rounded-md w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <CustomTable
          columns={columns}
          data={filteredResults.slice((currentPage - 1) * perPage, currentPage * perPage)}
          totalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          isLoading={isLoading}
          currentPage={currentPage}
          perPage={perPage}
        />
      </div>
    </div>
  );
}